import log from 'salvo-lite/log'
// eslint-disable-next-line no-unused-vars
import { tns } from 'tiny-slider/src/tiny-slider'

class AjaxSearchSlider {
    constructor (theme, elem) {
        this._elem = elem
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialising...', this)

        document.addEventListener('onSearchResults', (e) => {
            let sliders = e.sliders
            let anchors = e.anchors

            sliders.forEach((slider) => {
                // eslint-disable-next-line no-unused-vars
                let tnsSlider = tns(JSON.parse(slider.dataset.slider))
            })

            anchors.forEach((anchor) => {
                anchor.addEventListener('click', (event) => {
                    event.preventDefault()
                    anchor.querySelector('.tns-inner').addEventListener('click', (e) => {
                        window.location.href = anchor.href
                    })
                })
            })
        })
    }
}

export default AjaxSearchSlider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/AjaxSearchSliders.js